import { red } from '@mui/material/colors';
import { createTheme } from '@mui/material/styles';

// A custom theme for this app
const theme = createTheme({
  cssVariables: true,
  palette: {
    primary: {
      main: '#222222',
    },
    secondary: {
      main: '#a0013b',
    },
    error: {
      main: red.A400,
    },
  },
});

let theme_data = undefined;
export function theme_info(info_id) {
    // Get the browser language and load the appropriate language file
    if (theme_data == undefined) {
      const searchParams = new URLSearchParams(document.location.search);
      let client_id = searchParams.get("client_id")      
      console.log("Loaded client theme data")
      try {
        theme_data = require(`./clients/${client_id}.json`);
      } catch (e) {
        theme_data = require(`./clients/default.json`);
      }
    }
    return theme_data[info_id] ? theme_data[info_id] : undefined;
}

export default theme;